const rates = {
  forms: {
    information: {
      details: {
        fields: {
          supplierId: {
            name: 'Flotas',
          },
        },
      },
    },
  },
};

export default rates;
